import { createFileRoute } from "@tanstack/react-router";
import Terms from "@/pages/Terms";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/terms")({
  head: () =>
    pageHead({
      path: "/terms",
      title: "Conditions d'Utilisation | CMO Partner",
      description:
        "Conditions d'utilisation du site CMO Partner : services, propriété intellectuelle, responsabilité et droit applicable.",
      enPath: null,
      crumbs: [["Conditions d'utilisation", "/terms"]],
    }),
  component: Terms,
});
